import React, { memo } from 'react';
import TableRow from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/VolumeTable/TableRow';
import { IPeriod } from '@/creditflowresearch/domain/vo/League/IStandings';

import styles from './footer.module.scss';

interface IProps {
  hasAmount: boolean,
  periods: IPeriod[],
}

const Footer = ({ periods, hasAmount }:IProps) => (
  <tfoot className={ styles.footer }>
    <TableRow
      // @ts-ignore
      rowIndex="tfoot"
      periods={ periods }
      hasAmount={ hasAmount }
    />
  </tfoot>
);

export default memo(Footer);
